import { toast } from "react-toastify";
import defaultErrorHandler from "api/global/default-error-handler";
import {
    requestGetMiscChargeById,
    requestInsertMiscChargeById,
    requestUpdateMiscChargeById,
    requestDeleteMiscChargeById,

    requestGetMiscChargeTypes,
    requestInsertMiscChargeType,
    requestGetMiscChargeTypeById,
    requestUpdateMiscChargeTypeById,
    requestDeleteMiscChargeTypeById,

    requestGetMiscChargeRates,
    requestGetMiscChargeRatesSpecific,
    requestUpdateMiscChargeRates,
    requestMerchandisers
} from "api/menu/master-files/misc-charges/requests";

export const FETCH_MISC_CHARGES_LOADING = "FETCH_MISC_CHARGES_LOADING";
export const FETCH_MISC_CHARGES_ERROR = "FETCH_MISC_CHARGES_ERROR";
export const FETCH_MISC_CHARGE_BY_ID_SUCCESS = "FETCH_MISC_CHARGE_BY_ID_SUCCESS";
export const FETCH_MISC_CHARGE_TYPES_SUCCESS = "FETCH_MISC_CHARGE_TYPES_SUCCESS";
export const FETCH_MISC_CHARGE_TYPES_BY_ID_SUCCESS = "FETCH_MISC_CHARGE_TYPES_BY_ID_SUCCESS";
export const FETCH_MISC_CHARGE_RATES = "FETCH_MISC_CHARGE_RATES";
export const FETCH_MISC_CHARGE_RATES_SPECIFIC = "FETCH_MISC_CHARGE_RATES_SPECIFIC";
export const FETCH_MISC_CHARGE_MERCHANDISERS_SUCCESS = "FETCH_MISC_CHARGE_MERCHANDISERS_SUCCESS";

export const setLoading = (status) => ({
    type: FETCH_MISC_CHARGES_LOADING,
    payload: status
});

export const fetchMiscChargeById = (id) => dispatch => {
    if (id === true) {
        dispatch({
            type: FETCH_MISC_CHARGE_BY_ID_SUCCESS,
            payload: {}
        });
        return;
    }
    dispatch(setLoading(true));
    requestGetMiscChargeById(id)
        .then(response => {
            dispatch({
                type: FETCH_MISC_CHARGE_BY_ID_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_MISC_CHARGES_ERROR));
        });
};

export const insertMiscChargeById = (data, callback) => dispatch => {
    dispatch(setLoading(true));
    requestInsertMiscChargeById(data)
        .then(() => {
            callback();
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_MISC_CHARGES_ERROR));
        });
};

export const updateMiscChargeById = (id, data, callback) => dispatch => {
    dispatch(setLoading(true));
    requestUpdateMiscChargeById(id, data)
        .then(() => {
            callback();
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_MISC_CHARGES_ERROR));
        });
};

export const deleteMiscChargeById = (id, callback) => dispatch => {
    dispatch(setLoading(true));
    requestDeleteMiscChargeById(id)
        .then(() => {
            callback();
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_MISC_CHARGES_ERROR));
        });
};

export const fetchMiscChargeTypes = (includeInactive = false) => dispatch => {
    dispatch(setLoading(true));
    requestGetMiscChargeTypes(includeInactive)
        .then(response => {
            dispatch({
                type: FETCH_MISC_CHARGE_TYPES_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_MISC_CHARGES_ERROR));
        });
};

export const fetchMiscChargeTypeById = (id) => dispatch => {
    dispatch(setLoading(true));
    requestGetMiscChargeTypeById(id)
        .then(response => {
            dispatch({
                type: FETCH_MISC_CHARGE_TYPES_BY_ID_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_MISC_CHARGES_ERROR));
        });
};

export const insertMiscChargeType = (data, callback) => dispatch => {
    dispatch(setLoading(true));
    requestInsertMiscChargeType(data)
        .then(() => {
            callback();
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_MISC_CHARGES_ERROR));
        });
};

export const updateMiscChargeTypeById = (id, data, callback) => dispatch => {
    dispatch(setLoading(true));
    requestUpdateMiscChargeTypeById(id, data)
        .then(() => {
            callback();
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_MISC_CHARGES_ERROR));
        });
};

export const deleteMiscChargeTypeById = (id, callback) => dispatch => {
    dispatch(setLoading(true));
    requestDeleteMiscChargeTypeById(id)
        .then(() => {
            callback();
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_MISC_CHARGES_ERROR));
        });
};

export const getMiscChargeRates = (reset = false) => dispatch => {
    if (reset) {
        dispatch({
            type: FETCH_MISC_CHARGE_RATES,
            payload: {}
        });
        return;
    }
    dispatch(setLoading(true));
    requestGetMiscChargeRates()
        .then(response => {
            dispatch({
                type: FETCH_MISC_CHARGE_RATES,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_MISC_CHARGES_ERROR));
        });
};


export const getMiscChargeRatesSpecific = (employeeId, jobIdArr = []) => dispatch => {
    dispatch(setLoading(true));
    requestGetMiscChargeRatesSpecific(employeeId, jobIdArr)
        .then(response => {
            dispatch({
                type: FETCH_MISC_CHARGE_RATES_SPECIFIC,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_MISC_CHARGES_ERROR));
        });
};

export const updateMiscChargeRates = (data, callback) => dispatch => {
    dispatch(setLoading(true));
    requestUpdateMiscChargeRates(data)
        .then(() => {
            callback();
            dispatch(setLoading(false));
            toast("Misc charge rates successfully updated", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_MISC_CHARGES_ERROR));
        });
};

export const fetchMerchandisers = () => dispatch => {
    dispatch(setLoading(true));
    requestMerchandisers()
        .then(response => {
            dispatch({
                type: FETCH_MISC_CHARGE_MERCHANDISERS_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_MISC_CHARGES_ERROR));
        });
};
